














































































































































































































import Vue from 'vue'
import { staticitems } from '../example-data'

const sandboxTemplateHTML = `<v-tree-select
            :autocomplete="autocomplete"
            :chips="chips"
            :dense="dense"
            :multiple="multiple"
            :items="items"
            :clearable="clearable"
            :dark="dark"
          >
          <template v-if="customSlots" v-slot:prependTree="{ item, open }">
            <v-icon v-if = "item.children">{{ open ? "mdi-folder-open" : "mdi-folder" }}</v-icon>
            <v-icon v-else>mdi-file</v-icon>
          </template>
</v-tree-select>`

const sandboxCode = `export default ({
  data: () => ({
    items: staticitems, // see data source
    chips: false,
    multiple: false,
    dense: false,
    clearable: false,
    dark: false,
    autocomplete: false,
    customSlots: false
  })
})`

export default Vue.extend({
  data: () => ({
    items: staticitems,
    chips: false,
    multiple: false,
    dense: false,
    clearable: false,
    dark: false,
    autocomplete: false,
    customSlots: false,
    independent: true,
    deletableChips: false,
    smallChips: false,
    selectedItems: [],
    showFullPath: false,
    delimeter: '/',
    useToolbar: false,
    toolbarPosition: 'top-left',
    toolbarFlat: false,
    toolbarTopLeft: true,
    toolbarTopRight: false,
    toolbarBottomLeft: false,
    toolbarBottomRight: false,
    toolbarButtonTextVisible: false,
    //
    codeSandbox: false,
    sandboxTemplate: sandboxTemplateHTML,
    sandboxCode: sandboxCode,
    dataSource: staticitems,
    allowSelectParents: false,
    openOnePath: false
  }),
  methods: {
    getSelectionType () {
      return this.independent ? 'independent' : 'leaf'
    },
    SetToolbar (position: string) {
      this.toolbarPosition = position
      if (position === 'top-left') {
        this.toolbarTopLeft = true
        this.toolbarTopRight = false
        this.toolbarBottomLeft = false
        this.toolbarBottomRight = false
      } else if (position === 'top-right') {
        this.toolbarTopLeft = false
        this.toolbarTopRight = true
        this.toolbarBottomLeft = false
        this.toolbarBottomRight = false
      } else if (position === 'bottom-left') {
        this.toolbarTopLeft = false
        this.toolbarTopRight = false
        this.toolbarBottomLeft = true
        this.toolbarBottomRight = false
      } else {
        this.toolbarTopLeft = false
        this.toolbarTopRight = false
        this.toolbarBottomLeft = false
        this.toolbarBottomRight = true
      }
    },
    GetToolbar (position: string): boolean {
      return position === this.toolbarPosition
    }
  }
})
